export default {
  props: ['id'],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    loading() { return this.$store.state.loading; },
    sale() { return this.$store.state.sales.sale; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { /* + */ return this.$store.getters.isDealer; },
  },
  methods: {
    GetUnit({ product }) {
      return (product.unit && product.unit.short_name)
        ? product.unit.short_name
        : 'ед';
    },
    OpenDialog() {
      this.dialog = true;
    },
    CloseDialog() {
      this.dialog = false;
    },
    async RemoveSale() {
      await this.$store.dispatch('sales/DeleteSale', {
        profile_id: this.user.profile_id,
        sale_id: this.sale.id,
      })
        .then(() => this.$router.push('/sales'))
        .finally(() => this.CloseDialog());
    },
  },
  created() {
    if (this.isManager) {
      this.$router.push('/sales');
    }
  },
  mounted() {
    this.$store.dispatch('sales/GetSale', {
      profile_id: this.user.profile_id,
      sale_id: this.$props.id,
    });
  },
};
